import axiosClient from "./axiosClient";

// -------------------- Public API --------------------
// Get all listings (public, no auth required)
export const getAllListingsPublic = () =>
  axiosClient.get("/residence-listing/public");

// Get only published listings (public)
export const getPublishedListings = () =>
  axiosClient.get("/residence-listing/published");

// -------------------- Authenticated API --------------------
// Get all listings for the logged-in resident
export const getListings = () => axiosClient.get("/residence-listing");

// Add a new listing
export const addListing = (payload) =>
  axiosClient.post("/residence-listing", payload);

// Update a listing
export const updateListing = (id, payload) =>
  axiosClient.patch(`/residence-listing/${id}`, payload);

// Delete a listing
export const deleteListing = (id) =>
  axiosClient.delete(`/residence-listing/${id}`);

// Toggle publish status
export const updatePublishStatus = (id, status) =>
  axiosClient.patch(`/residence-listing/${id}/publish`, { status });

// Toggle action status (sold/rented)
export const toggleActionStatus = (id) =>
  axiosClient.patch(`/residence-listing/${id}/action-status`);

// -------------------- Residence Requests --------------------
// Add a new request
export const addResidenceRequest = (listingId) =>
  axiosClient.post(`/residence-listing/${listingId}/requests`);

// Get all requests for the logged-in resident
export const getResidenceRequests = () =>
  axiosClient.get("/residence-listing/requests");

// Delete a request by ID
export const deleteResidenceRequest = (requestId) =>
  axiosClient.delete(`/residence-listing/requests/${requestId}`);

// Approve or reject a request
export const updateRequestStatus = (requestId, status) =>
  axiosClient.put(`/residence-listing/requests/${requestId}`, { status });
